module.exports = "<div class=\"error-block red\" *ngIf=\"errorMessage !== null\">\n  {{errorMessage}}\n</div>\n"